import React from 'react';
import PropTypes from 'prop-types';
import { Header, Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiHeader
 * Display the semantic component header with the corresponding mode
 * Props (parameters)
 * @param string header = [h1, h2, h3, h2, h5]
 * @param string|object icon: the icon can be the name of the icon or an object. If the
 * icon is an string then the semantic component icon will be used
 * @param string content = title
 * @param string subHeader
 * @param string mode
 */
export default class UiHeader extends React.PureComponent {
  render() {
    const { header, icon, content, subHeader, mode } = this.props;
    const styleContent = {};
    const styleIcon = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleContent.color = colors.TEXT_COLOR;
      styleIcon.color = colors.TEXT_COLOR;
    }

    return (
      <Header as={header}>
        {typeof icon === 'string' ? (
          <Icon name={icon} style={styleIcon} />
        ) : (
          icon
        )}
        <Header.Content style={styleContent}>
          {content}
          {subHeader && (
            <Header.Subheader style={styleContent}>
              {subHeader}
            </Header.Subheader>
          )}
        </Header.Content>
      </Header>
    );
  }
}

UiHeader.propTypes = {
  header: PropTypes.string,
  icon: PropTypes.string,
  content: PropTypes.string,
  subHeader: PropTypes.string,
  mode: PropTypes.string,
};

UiHeader.defaultProps = {
  header: 'h1',
  icon: null,
  content: null,
  subHeader: null,
  mode: null,
};
